import React from "react";
import "./sponserblock.css"; // if you have styling

const SponserBlock = ({ image, name, subtitle, description, order }) => {
  return (
    <div className={`sponser-ss-block-ui bg-custom brightness ${order}`}>
      {/* Image */}
      <div className="ssb-img">
        <img className="brightness" src={image} alt={name} />
        {/* <iframe
              src={image}
              title={name}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
          ></iframe> */}
      </div>

      {/* Content */}
      <div className="ssb-cnt">
        <div className="ssb-title">
          <h2 className="text-clip">{name}</h2>
          <span className="text-clip">{subtitle}</span>
        </div>

        <div className="ssb-desc">
          <p className="text-clip">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default SponserBlock;
